import { render, staticRenderFns } from "./AddIndividualPage.vue?vue&type=template&id=4b7a5b29&scoped=true&"
import script from "./AddIndividualPage.vue?vue&type=script&lang=js&"
export * from "./AddIndividualPage.vue?vue&type=script&lang=js&"
import style0 from "./AddIndividualPage.vue?vue&type=style&index=0&id=4b7a5b29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a5b29",
  null
  
)

export default component.exports